import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import i18n from "./i18n";

const WithTranslate = (props) => {
  const { t } = useTranslation();
  const medium = useSelector(
    (state) => state.userDetailsData.LoginDetails.mediumOfInstruction
  );

  useEffect(() => {
    if (medium || props.Medium) {
      i18n.changeLanguage(medium?.toString() || props.Medium);
      //i18n.changeLanguage("English");
    }
  }, [medium, props.Medium]);

  return <>{t(props.name)}</>;
};

export default WithTranslate;
